import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  fill: "currentColor",
  viewBox: "0 0 30 19"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M15.17 18.68c-.22 0-.43-.09-.58-.25L6.67 9.88c-2.06-2.22-2.06-5.82 0-8.03C7.69.75 9.04.15 10.48.15s2.79.6 3.81 1.7l.89.96.88-.95C17.08.77 18.43.16 19.87.16s2.79.6 3.81 1.7c2.06 2.22 2.06 5.82 0 8.03l-7.93 8.54c-.15.16-.36.25-.58.25M10.48 1.73c-.99 0-1.94.42-2.65 1.19-1.5 1.62-1.5 4.25 0 5.88l7.34 7.92 7.35-7.91c1.51-1.62 1.51-4.26 0-5.88a3.618 3.618 0 0 0-5.3 0L15.76 4.5a.82.82 0 0 1-1.16 0l-1.47-1.58c-.71-.76-1.65-1.19-2.65-1.19" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }